import { Text } from '@axilon-apps/libs-ui-shadcn'

const EmptyTable = () => (
  <Text as="p" className="pb-3 text-center font-bold">
    No records found
  </Text>
)

export default EmptyTable
